module.exports = __webpack_public_path__ + "static/img/create02.fa00138.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/create02.svg
// module id = PBwv
// module chunks = 3